module.exports = __webpack_public_path__ + "static/media/mindset-large@2x.95ef3db4.png";